"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iZiSwapError = exports.SDKModule = void 0;
var SDKModule;
(function (SDKModule) {
    SDKModule["SWAP_QUERY"] = "SWAP_QUERY";
    SDKModule["POOL"] = "POOL";
})(SDKModule = exports.SDKModule || (exports.SDKModule = {}));
class iZiSwapError extends Error {
    constructor(module, code, msg = '') {
        super(msg);
        this.code = code;
        this.module = module;
    }
}
exports.iZiSwapError = iZiSwapError;
